import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import App from "./App.js";
import Anagrafiche2 from "./components/registryComponent/Anagrafiche2.js";
import AttivitaDet1 from "./components/activity/AttivitaDet1.js";
import Dashboard from "./components/dashboard/Dashboard.js";
import reportWebVitals from "./reportWebVitals.js";
import LogIn from "./components/LogIn.js";
import { WebSocketLink } from "apollo-link-ws";
import { getCookie, deleteCookie } from "./utilis/utils";
import { useHistory } from "react-router-dom";
import ResetPassword from "./components/resetPassword/resetPassword.js";
import "bootstrap/dist/css/bootstrap.min.css";

import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import CardMenu from "./components/Card/CardMenu.js";
import { getLoginUrl } from './config/env.js';

ReactDOM.render(
	<React.StrictMode>
		<Root />
	</React.StrictMode>,
	document.getElementById("root")
);

function Root() {
	const history = useHistory();
	const [header, setHeader] = React.useState({
		connectionParams: () => {
			return {
				headers: { Authorization: `Bearer ${getCookie("accessToken")}` },
			};
		},
	});
	const [wsLink] = React.useState(
		new WebSocketLink({
			uri: process.env.REACT_APP_BACKEND_WS,
			reconnect: true,
			options: header,
		})
	);

	const clearStorageAndCookies = () => {
		deleteCookie("accessToken");
		deleteCookie("refreshToken");
		localStorage.clear();
		sessionStorage.clear();
		if (window.location.pathname !== "/") {
			window.location.href = window.location.origin + "/";
		}
	};
	function setCookie(cookie) {
		let cookieString = `${cookie.name}=${cookie.value}`;
		if (cookie.path) {
			cookieString = `${cookieString}; path=${cookie.path}`;
		}
		if (cookie.maxAge) {
			cookieString = `${cookieString}; max-age=${cookie.maxAge}`;
		}
		document.cookie = cookieString;
	}

	const getNewToken = async (refreshToken) => {
		const url = getLoginUrl('/api/login/refresh/');
		const data = {
			refresh: refreshToken,
		};

		fetch(url, {
			method: "POST",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		})
			.then((response) => response.json())
			.then((result) => {
				let accessToken = result?.access;
				setCookie({
					name: "accessToken",
					value: accessToken,
					maxAge: process.env.REACT_APP_EXPIRATION_SECONDS,
				});
				let refreshToken = result?.refresh;
				if (refreshToken) {
					setCookie({
						name: "refreshToken",
						value: refreshToken,
						maxAge: process.env.REACT_APP_EXPIRATION_SECONDS,
					});
				}
				setHeader({
					connectionParams: () => {
						return { headers: { Authorization: `Bearer ${accessToken}` } };
					},
				});
				if (!accessToken) {
					clearStorageAndCookies();
				}
			})
			.catch((error) => {
				clearStorageAndCookies();
				console.error("Si è verificato un errore:", error);
			});
	};

	/* function handleWebSocketError(errorEvent) {
      console.error('WebSocket connection error:', errorEvent);
      const refreshToken=getCookie("refreshToken");
      getNewToken(refreshToken);
    }*/

	//wsLink.subscriptionClient.on('error', handleWebSocketError);

	const client = new ApolloClient({
		link: wsLink,
		cache: new InMemoryCache(),
		onError: ({ networkError, graphQLErrors }) => {
			if (graphQLErrors) {
				const refreshToken = getCookie("refreshToken");
				graphQLErrors.forEach((error) => {
					const errorMessage = error.message;
					if (
						errorMessage === "Signature has expired" ||
						errorMessage === "You do not have permission to perform this action"
					) {
						// getNewToken(refreshToken);
					}
				});
			}
		},
	});

	return (
		<Router>
			<Route exact path="/">
				<LogIn />
			</Route>
			<Route
				path="/reset-password/:id"
				render={(props) => <ResetPassword {...props} />}
			/>
			<ApolloProvider client={client}>
				<Route path="/home">
					<App />
				</Route>
				<Route path="/anagrafiche2">
					<Anagrafiche2 />
				</Route>
				<Route path="/attivita">
					<AttivitaDet1 />
				</Route>
				<Route path="/dashboard">
					<Dashboard />
				</Route>
			</ApolloProvider>
		</Router>
	);
}

reportWebVitals();
